import { c as _c } from "react/compiler-runtime";
import { InfoIcon } from "@justhome/react-ui";
import clsx from "clsx";
import { FC, ReactElement, ReactNode } from "react";
interface MaximumBudgetResultRowProps {
  label: string;
  value: string | ReactElement;
  info?: string | ReactNode;
  isResult?: boolean;
}
const MaximumBudgetResultRow: FC<MaximumBudgetResultRowProps> = t0 => {
  const $ = _c(13);
  const {
    label,
    info,
    value,
    isResult
  } = t0;
  let t1;
  if ($[0] !== isResult) {
    t1 = clsx("flex flex-col flex-1 justify-center items-center", {
      "bg-primary-50 py-s text-body-1 font-semibold": isResult
    });
    $[0] = isResult;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== label) {
    t2 = <span className="text-body-2 text-neutral-425">{label}</span>;
    $[2] = label;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== info) {
    t3 = info && <InfoIcon>{info}</InfoIcon>;
    $[4] = info;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3 || $[7] !== value) {
    t4 = <span className="text-body-1 text-primary-800 flex items-center gap-2xs">{value}{t3}</span>;
    $[6] = t3;
    $[7] = value;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t4) {
    t5 = <p className={t1}>{t2}{t4}</p>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export default MaximumBudgetResultRow;